import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';
import styles from '../../style/rulesEngine';
import ConditionRow from './ConditionRow';

const ConditionGroup = ({ conditions, logicOperator, onLogicChange, onConditionChange, onConditionRemove, onConditionAdd, errors }) => {
  const toggleLogic = () => onLogicChange(logicOperator === 'all' ? 'any' : 'all');

  return (
    <View>
      {/* "When [ANY/ALL] of the following match" */}
      <View style={styles.whenRow}>
        <Text style={styles.whenWord}>When</Text>
        <TouchableOpacity onPress={toggleLogic} style={styles.logicPill}>
          <Text style={styles.logicPillText}>
            {logicOperator === 'all' ? 'ALL' : 'ANY'}
          </Text>
        </TouchableOpacity>
        <Text style={styles.whenSubText}>of the following match</Text>
      </View>

      {/* Condition rows — wrapped with decreasing zIndex for dropdown stacking */}
      {conditions.map((cond, i) => (
        <View key={i} style={{ zIndex: conditions.length - i, position: 'relative' }}>
          <ConditionRow
            condition={cond}
            index={i}
            onChange={onConditionChange}
            onRemove={onConditionRemove}
            isOnly={conditions.length === 1}
            errors={errors}
          />
        </View>
      ))}

      {/* Centered + Add Condition */}
      <View style={styles.addCenteredButton}>
        <TouchableOpacity onPress={onConditionAdd} style={styles.addCenteredInner}>
          <Text style={styles.addCenteredText}>Add Condition</Text>
          <i className="icon-plus" style={{ color: '#fff', fontSize: 45 }} />
        </TouchableOpacity>
      </View>

      {errors?.conditions && (
        <Text style={styles.errorText}>{errors.conditions}</Text>
      )}
    </View>
  );
};

ConditionGroup.propTypes = {
  conditions: PropTypes.arrayOf(PropTypes.object).isRequired,
  logicOperator: PropTypes.string.isRequired,
  onLogicChange: PropTypes.func.isRequired,
  onConditionChange: PropTypes.func.isRequired,
  onConditionRemove: PropTypes.func.isRequired,
  onConditionAdd: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export default ConditionGroup;
